import React from 'react';

import moment from 'moment';
import ExternalLinkButton from '../../../../../elements/Button/ExternalLinkButton/ExternalLinkButton';
import ExternalMeetingLinkButton from '../../../../../elements/Button/ExternalMeetingLinkButton';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import WaitingRoomButton from './WaitingRoomButton';

const WaitingRoomItem = (props) => {
    const { color, activeParticipants = [], eventId, nextProgramItem } = props,
        i18n = props.i18n || useI18n(),
        {
            name,
            start_utc,
            session_content_button_label,
            session_content_url,
            session_content_display_time,
            waiting_room_display_time,
            session_content_url_target,
            session_content_type,
            virtualroom_url,
            _state,
            id,
        } = nextProgramItem,
        buttonContext = {
            session_content_url,
            session_content_url_target,
            session_content_button_label,
            session_content_type,
            session_content_display_time,
            start_utc,
            eventId,
            primary_color: color,
            programId: id,
        },
        now = moment(),
        activeCorridor = session_content_url && moment(start_utc).diff(now, 'minutes') <= waiting_room_display_time,
        targetIframe = session_content_url_target === 'iframe';

    return (
        <div>
            <table className="layout" style={{ marginTop: 10 }}>
                <tbody>
                    <tr>
                        <td>
                            {session_content_url ? <ExternalLinkButton {...buttonContext} style={{ backgroundColor: color }} /> : ''}
                            {virtualroom_url ? (
                                <ExternalMeetingLinkButton
                                    {...nextProgramItem}
                                    eventId={eventId}
                                    disabled={moment(start_utc).diff(now, 'minutes') > 10}
                                    meetingId={nextProgramItem.id}
                                    style={{ backgroundColor: color }}
                                />
                            ) : (
                                ''
                            )}
                        </td>
                        {activeCorridor ? (
                            <td
                                className="homeScreenWaitingRoomButton"
                                style={{
                                    width: '33%',
                                }}>
                                <WaitingRoomButton i18n={i18n} color={color} activeParticipants={activeParticipants} />
                            </td>
                        ) : null}
                    </tr>
                </tbody>
            </table>
        </div>
    );

    function getSecondsToStart(startDate) {
        const now = moment(),
            timeDifference = moment(startDate).diff(now, 'seconds');
        return timeDifference;
    }
};

export default WaitingRoomItem;
